import React from 'react';
import { Navbar } from '../components/Navbar';
import { ConsularAffairs } from '../components/ConsularAffairs';
import { Footer } from '../components/Footer';
import { FeedbackPopup } from '../components/FeedbackPopup';
export function ConsularPage() {
  return <div className="font-nunito w-full min-h-screen overflow-x-hidden" data-id="element-2496">
      <Navbar data-id="element-2497" />
      <main data-id="element-2498">
        <ConsularAffairs data-id="element-2499" />
      </main>
      <Footer data-id="element-2500" />
      <FeedbackPopup data-id="element-2501" />
    </div>;
}